'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _WhatsApp_Logo = require('../../../static/icons/WhatsApp_Logo.png');var _WhatsApp_Logo2 = _interopRequireDefault(_WhatsApp_Logo);

var _WhatsAppWidget = require('./WhatsAppWidget.scss');var styles = _interopRequireWildcard(_WhatsAppWidget);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var TARGET_PHONE_NUMBER = 972546137700; // styles
var WHATS_APP_LINK = 'https://wa.me/';

var WhatsAppWidget = function WhatsAppWidget(props) {return (
    _react2.default.createElement('div', { className: styles.widgetWrapper },
      _react2.default.createElement('a', { href: '' + WHATS_APP_LINK + TARGET_PHONE_NUMBER, target: '_blank' },
        _react2.default.createElement('img', { src: _WhatsApp_Logo2.default, alt: '' }),
        _react2.default.createElement('span', null, props.translate ? props.translate('messageUs') : ''))));};




WhatsAppWidget.propTypes = {
  translate: _propTypes2.default.func };exports.default =


WhatsAppWidget;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/WhatsAppWidget/WhatsAppWidget.js
// module id = 142
// module chunks = 0